/* KAMASHH N°5
   30g = White, Pistachio, Black
   50g = Pistachio, Black
   60g = Pistachio, Black

   White is hidden completely for 50g and 60g.
*/

(function () {

  /* Run only on the N°5 product page */
  if (
    window.location.pathname.indexOf(
      '/products/best-ceremonial-matcha-india'
    ) === -1
  ) {
    return;
  }


  function getSize(value) {

    value = String(value || '').trim().toLowerCase();

    if (value.indexOf('30g') === 0) {
      return '30g';
    }

    if (value.indexOf('50g') === 0) {
      return '50g';
    }

    if (value.indexOf('60g') === 0) {
      return '60g';
    }

    return '';
  }


  function updateN5TinFinish() {

    var radios =
      document.querySelectorAll('input[type="radio"]');

    var selectedSize = '';
    var whiteInput = null;
    var pistachioInput = null;
    var i;


    /* Identify selected size + tin finish inputs */
    for (i = 0; i < radios.length; i++) {

      var value =
        String(radios[i].value || '').trim();

      var lowerValue =
        value.toLowerCase();


      /* Selected size */
      if (radios[i].checked) {

        var size = getSize(value);

        if (size) {
          selectedSize = size;
        }

      }


      /* White tin */
      if (lowerValue === 'white') {
        whiteInput = radios[i];
      }


      /* Pistachio tin */
      if (
        lowerValue === 'pistachio' ||
        lowerValue === 'pistachio green'
      ) {
        pistachioInput = radios[i];
      }

    }


    if (!selectedSize || !whiteInput) {
      return;
    }


    /* Find the visible White button/label */
    var whiteLabel = null;

    if (
      whiteInput.labels &&
      whiteInput.labels.length > 0
    ) {
      whiteLabel = whiteInput.labels[0];
    }


    if (!whiteLabel) {
      return;
    }


    /*
      50g / 60g:
      completely hide White
    */
    if (
      selectedSize === '50g' ||
      selectedSize === '60g'
    ) {

      whiteLabel.style.display = 'none';


      /*
        If user was previously on 30g White
        and moves to 50g/60g,
        automatically select Pistachio.
      */
      if (
        whiteInput.checked &&
        pistachioInput &&
        !pistachioInput.disabled
      ) {
        pistachioInput.click();
      }

    }


    /*
      30g:
      show White again
    */
    else {

      whiteLabel.style.display = '';

    }

  }


  /* Run when page first loads */
  function initialise() {

    updateN5TinFinish();

    /* Run again after Shopify finishes rendering variants */
    setTimeout(updateN5TinFinish, 100);
    setTimeout(updateN5TinFinish, 300);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();

  }


  /*
    Run whenever Size or Tin Finish changes.
    Multiple short delays allow Shopify's native
    variant picker to finish updating first.
  */
  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target &&
        event.target.matches('input[type="radio"]')
      ) {

        setTimeout(updateN5TinFinish, 30);
        setTimeout(updateN5TinFinish, 120);

      }

    }
  );


  /* Shopify/theme variant event */
  document.addEventListener(
    'variant:change',
    function () {

      setTimeout(updateN5TinFinish, 30);
      setTimeout(updateN5TinFinish, 120);

    }
  );


})();